module.exports = __webpack_public_path__ + "static/media/globalServices.8f4414aa.png";